import { Component, OnInit } from '@angular/core';
import { Cart, CartQuery } from '@fgb/core';
import { NavigationService } from '@fgb/portal-component-library/src/lib/shared/services';

@Component({
  selector: 'fgb-portal-product-success-page',
  templateUrl: './portal-product-success-page.component.html',
  styleUrls: ['./portal-product-success-page.component.scss'],
})
export class PortalProductSuccessPageComponent implements OnInit {
  cartItem: Cart;

  constructor(private cart: CartQuery, private navigationService: NavigationService) { }

  ngOnInit() {
    this.cartItem = this.cart.getMemberPortalProductCart()[0];

    this.navigationService.hideMobileNav();
  }

  ngOnDestroy(): void {
    this.navigationService.showMobileNav();
  }
}
